import { render, staticRenderFns } from "./RuleManagerPiAddExactMatchRule.vue?vue&type=template&id=e22427ae&scoped=true&"
import script from "./RuleManagerPiAddExactMatchRule.vue?vue&type=script&lang=js&"
export * from "./RuleManagerPiAddExactMatchRule.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerPiAddExactMatchRule.vue?vue&type=style&index=0&id=e22427ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22427ae",
  null
  
)

export default component.exports